export const getBlogSidebar = async (locale: string) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/items/blog_sidebar_translations?fields=*,popular_articles.blog_translations_id.name,popular_articles.blog_translations_id.slug&filter={"languages_code":{"_eq":"${locale}"}}`
    );
    if (response.ok) {
      const responseData = await response.json();
      return responseData.data[0];
    }
  } catch (error) {
    console.log(error);
  }
};
